import { createServerFn } from "@tanstack/react-start";
import { getRequest, setResponseHeader } from "@tanstack/react-start/server";

export const startOnboarding = createServerFn()
	.inputValidator((channelUid: string) => channelUid)
	.handler(({ data }) => {
		const request = getRequest();

		const onboardingCookie =
			request.headers
				.get("cookie")
				?.split("; ")
				.find((row) => row.startsWith("onboarding="))
				?.split("=")[1] ?? "";
		const onboardingChannels = onboardingCookie.split(",");

		onboardingChannels.push(data);

		setResponseHeader(
			"Set-Cookie",
			`onboarding=${[...onboardingChannels].join(",")}; Path=/; HttpOnly; SameSite=Lax`,
		);

		return true;
	});

export const getOnboardingChannels = createServerFn().handler(() => {
	const request = getRequest();

	const onboardingCookie =
		request.headers
			.get("cookie")
			?.split("; ")
			.find((row) => row.startsWith("onboarding="))
			?.split("=")[1] ?? "";

	return onboardingCookie.split(",");
});

export const stopOnboarding = createServerFn()
	.inputValidator((channelUid: string) => channelUid)
	.handler(({ data }) => {
		const request = getRequest();

		const onboardingCookie =
			request.headers
				.get("cookie")
				?.split("; ")
				.find((row) => row.startsWith("onboarding="))
				?.split("=")[1] ?? "";
		const onboardingChannels = onboardingCookie.split(",");

		setResponseHeader(
			"Set-Cookie",
			`onboarding=${[...onboardingChannels.filter((id) => id !== data)].join(",")}; Path=/; HttpOnly; SameSite=Lax`,
		);

		return true;
	});
